<template>
  <div>
    <!--创建计划中间部分-->
    <div style="background-color: #232323;">
      <div class="content">
        <a-form ref="valueRef" layout="horizontal" :hideRequiredMark="true" :rules="rules" :model="planBody" labelAlign="left">
          <a-form-item label="计划名称" name="name" :labelCol="{ span: 24 }">
            <a-input style="background: black; width: 98%;" placeholder="请输入计划名称" v-model:value="planBody.name" />
          </a-form-item>
          <a-form-item label="设备" :wrapperCol="{ offset: 7 }" v-model:value="planBody.dock_sn" name="dock_sn">
            <router-link :to="{ name: 'select-plan' }" @click="selectDevice">选择设备</router-link>
          </a-form-item>
          <a-form-item v-if="planBody.dock_sn" style="margin-top: -15px;">
            <div class="panel" style="padding-top: 5px;">
              <div class="title">
                <a-tooltip :title="dock.nickname">
                  <div class="pr10"
                    style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{
                    dock.nickname }}</div>
                </a-tooltip>
              </div>
              <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
                <span>
                  <RocketOutlined />
                </span>
                <span class="ml5">{{ dock.children?.nickname ?? 'No drone' }}</span>
              </div>
            </div>
          </a-form-item>
          <a-form-item label="航线" :wrapperCol="{ offset: 7 }" name="file_id">
            <router-link :to="{ name: 'select-plan' }" @click="selectRoute">
              选择航线
            </router-link>
          </a-form-item>
          <a-form-item v-if="planBody.file_id" style="margin-top: -15px;">
            <div class="wayline-panel" style="padding-top: 5px;">
              <div class="title">
                <a-tooltip :title="wayline.name">
                  <div class="pr10"
                    style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{
                    wayline.name }}</div>
                </a-tooltip>
                <div class="ml10">
                  <UserOutlined />
                </div>
                <a-tooltip :title="wayline.user_name">
                  <div class="ml5 pr10"
                    style="width: 80px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{
                    wayline.user_name }}</div>
                </a-tooltip>
              </div>
              <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
                <span>
                  <RocketOutlined />
                </span>
                <span class="ml5">{{ DEVICE_NAME[wayline.drone_model_key] }}</span>
                <span class="ml10">
                  <CameraFilled style="border-top: 1px solid; padding-top: -3px;" />
                </span>
                <span class="ml5" v-for="payload in wayline.payload_model_keys" :key="payload.id">
                  {{ DEVICE_NAME[payload] }}
                </span>
              </div>
              <div class="mt5 ml10" style="color: hsla(0,0%,100%,0.35);">
                <span class="mr10">更新于 {{ new Date(wayline.update_time).toLocaleString() }}</span>
              </div>
            </div>
          </a-form-item>

          <a-form-item label="飞手" :labelCol="{ span: 24 }" name="pilotId" >
            <a-select v-model:value="planBody.pilotId" placeholder="请选择飞手" @change="handlePilotChange">
              <a-select-option v-for="item in pilotData" :key="item.id" :value="item.id">{{ item.username }}</a-select-option>
            </a-select>
          </a-form-item>

          <!-- <a-form-item label="任务场景" :labelCol="{ span: 24 }" name="job_type" >
            <a-select v-model:value="planBody.job_type" placeholder="请选择任务场景">
              <a-select-option v-for="item in jobTypeData" :key="item.dictCode" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
            </a-select>
          </a-form-item> -->

          <a-form-item label="任务专题" :labelCol="{ span: 24 }" name="specialTopicId" >
            <a-tree-select v-model:value="planBody.specialTopicId" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="specialTopicList"
              placeholder="请选择关联专题" @change="handleSpecialTopicChange"/>
          </a-form-item>

          <a-form-item label="任务类型" class="plan-timer-form-item" labelAlign="top" :labelCol="{ span: 24 }">
            <div style="display: block; white-space: nowrap;">
              <a-radio-group v-model:value="planBody.task_type" button-style="solid">
                <a-radio-button v-for="type in TaskTypeOptions" :value="type.value" :key="type.value">{{ type.label}}</a-radio-button>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item style="background-color: #232323 !important;" label="日期"
            v-if="planBody.task_type === TaskType.Timed || planBody.task_type === TaskType.Condition"
            name="select_execute_date" :labelCol="{ span: 24 }">
            <!-- <a-range-picker v-model:value="planBody.select_execute_date"
              :disabledDate="(current: Moment) => current < moment().subtract(1, 'days')" format="YYYY-MM-DD"
              :placeholder="['开始时间', '结束时间']" class="range-pi" /> -->

              <a-range-picker v-model="planBody.select_execute_date" :disabledDate="(current: Moment) => current < moment().subtract(1, 'days')" dateFormat="YYYY-MM-DD"/>
          </a-form-item>
          <a-form-item label="时间"
            v-if="planBody.task_type === TaskType.Timed || planBody.task_type === TaskType.Condition"
            name="select_execute_time" ref="select_execute_time" :labelCol="{ span: 24 }" :autoLink="false">
            <div class="mb10 flex-row flex-align-center flex-justify-around" v-for="n in planBody.select_time_number"
              :key="n">
              <a-time-picker v-model:value="planBody.select_time[n - 1][0]" format="HH:mm:ss" show-time
                placeholder="开始时间" :style="planBody.task_type === TaskType.Condition ? 'width: 50%' : 'width: 82%'"
                @change="() => $refs.select_execute_time.onFieldChange()" />
              <template v-if="planBody.task_type === TaskType.Condition">
                <div><span style="color: white;">—</span></div>
                <a-time-picker v-model:value="planBody.select_time[n - 1][1]" format="HH:mm:ss" show-time
                  placeholder="结束时间" style="width: 50%;" />
              </template>
              <div class="ml5" style="font-size:18px">
                <PlusCircleOutlined class="mr5" style="color: #1890ff" @click="addTime" />
                <MinusCircleOutlined :style="planBody.select_time_number === 1 ? 'color: gray' : 'color: red;'"
                  @click="removeTime" />
              </div>
            </div>
          </a-form-item>
          <template v-if="planBody.task_type === TaskType.Condition">
            <a-form-item label="开始任务时电池电量达到" :labelCol="{ span: 24 }" name="min_battery_capacity">
              <a-input-number style="width: 98%;" v-model:value="planBody.min_battery_capacity" :min="50" :max="100"
                :formatter="(value: number) => `${value}%`" :parser="(value: string) => value.replace('%', '')">
              </a-input-number>
            </a-form-item>
            <a-form-item label="开始任务时存储空间达到(MB)" :labelCol="{ span: 24 }" name="storage_capacity">
              <a-input-number v-model:value="planBody.min_storage_capacity" style="width: 98%;">
              </a-input-number>
            </a-form-item>
          </template>
          <!-- <a-form-item label="RTH 高度相对地面站(m)" :labelCol="{ span: 24 }" name="rth_altitude">
            <a-input-number v-model:value="planBody.rth_altitude" :min="20" :max="1500" style="width: 98%;" required>
            </a-input-number>
          </a-form-item> -->
          <a-form-item label="失联动作" :labelCol="{ span: 24 }" name="out_of_control_action" class="out_of_control_action">
            <div style="white-space: nowrap;">
              <a-radio-group v-model:value="planBody.out_of_control_action" button-style="solid">
                <a-radio-button v-for="action in OutOfControlActionOptions" :value="action.value" :key="action.value">
                  {{ action.label }}
                </a-radio-button>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item label="是否自动生成报告" :labelCol="{ span: 24 }" name="generate_report" class="generate_report">
            <div style="white-space: nowrap;">
              <a-radio-group v-model:value="planBody.generate_report" button-style="solid">
                <a-radio-button :value="true">是</a-radio-button>
                <a-radio-button :value="false">否</a-radio-button>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item label="是否开启视频分析" :labelCol="{ span: 24 }" name="is_analysis" class="is_analysis">
            <div style="white-space: nowrap;">
              <a-radio-group v-model:value="planBody.is_analysis" button-style="solid">
                <a-radio-button :value="true">是</a-radio-button>
                <a-radio-button :value="false">否</a-radio-button>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item label="任务描述" :labelCol="{ span: 24 }" name="remark" class="remark">
            <a-textarea v-model:value="planBody.remark" placeholder="请输入任务描述" :auto-size="{ minRows: 2, maxRows: 5 }" />
          </a-form-item>
        </a-form>
      </div>
      <!--按钮buttton-->
      <div class="footer">
        <a-button class="mr10" style="background: #3c3c3c;" @click="closePlan">取消
        </a-button>
        <a-button type="primary" @click="onSubmit" :disabled="disabled">创建
        </a-button>
      </div>
    </div>
    <div v-if="drawerVisible"
      :style="{ position: 'absolute', left: '360px', width: routeName === 'WaylinePanel' ? '450px' : '280px', height: '100vh', float: 'right', top: '0px', zIndex: 1000, color: 'white', background: '#282828' }">
      <div>
        <router-view :name="routeName" />
      </div>
      <div style="position: absolute; top: 15px; right: 10px; z-index: 10;">
        <a style="color: white;" @click="closePanel">
          <CloseOutlined />
        </a>
      </div>
    </div>

  </div>

  <!-- <div class="create-plan-wrapper">
    <div class="plan-content">

    <div class="content">
      <p style="margin-left: 10px; font-size: 18px;">创建计划</p>
      <a-form ref="valueRef" layout="horizontal" :hideRequiredMark="true" :rules="rules" :model="planBody" labelAlign="left">
        <a-form-item label="计划名称" name="name" :labelCol="{span: 23}">
          <a-input style="background: black;"  placeholder="请输入计划名称" v-model:value="planBody.name"/>
        </a-form-item> -->
  <!-- 航线 -->
  <!-- <a-form-item label="航线" :wrapperCol="{offset: 7}" name="file_id">
          <router-link
            :to="{name: 'select-plan'}"
            @click="selectRoute"
          >
          选择航线
          </router-link>
        </a-form-item>
        <a-form-item v-if="planBody.file_id" style="margin-top: -15px;">
          <div class="wayline-panel" style="padding-top: 5px;">
            <div class="title">
              <a-tooltip :title="wayline.name">
                <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ wayline.name }}</div>
              </a-tooltip>
              <div class="ml10"><UserOutlined /></div>
              <a-tooltip :title="wayline.user_name">
                <div class="ml5 pr10" style="width: 80px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ wayline.user_name }}</div>
              </a-tooltip>
            </div>
            <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
              <span><RocketOutlined /></span>
              <span class="ml5">{{ DEVICE_NAME[wayline.drone_model_key] }}</span>
              <span class="ml10"><CameraFilled style="border-top: 1px solid; padding-top: -3px;" /></span>
              <span class="ml5" v-for="payload in wayline.payload_model_keys" :key="payload.id">
                {{ DEVICE_NAME[payload] }}
              </span>
            </div>
            <div class="mt5 ml10" style="color: hsla(0,0%,100%,0.35);">
              <span class="mr10">Update at {{ new Date(wayline.update_time).toLocaleString() }}</span>
            </div>
          </div>
        </a-form-item> -->
  <!-- 设备 -->
  <!-- <a-form-item label="设备" :wrapperCol="{offset: 10}" v-model:value="planBody.dock_sn" name="dock_sn">
          <router-link
            :to="{name: 'select-plan'}"
            @click="selectDevice"
          >选择设备</router-link>
        </a-form-item>
        <a-form-item v-if="planBody.dock_sn" style="margin-top: -15px;">
          <div class="panel" style="padding-top: 5px;">
            <div class="title">
              <a-tooltip :title="dock.nickname">
                <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ dock.nickname }}</div>
              </a-tooltip>
            </div>
            <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
              <span><RocketOutlined /></span>
              <span class="ml5">{{ dock.children?.nickname ?? 'No drone' }}</span>
            </div>
          </div>
        </a-form-item> -->
  <!-- 任务类型 -->
  <!-- <a-form-item label="任务类型" class="plan-timer-form-item">
          <div style="white-space: nowrap;">
            <a-radio-group v-model:value="planBody.task_type" button-style="solid">
              <a-radio-button v-for="type in TaskTypeOptions" :value="type.value" :key="type.value">{{ type.label }}</a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item> -->
  <!-- execute date -->
  <!-- <a-form-item label="日期" v-if="planBody.task_type === TaskType.Timed || planBody.task_type === TaskType.Condition" name="select_execute_date" :labelCol="{span: 23}">
          <a-range-picker
            v-model:value="planBody.select_execute_date"
            :disabledDate="(current: Moment) => current < moment().subtract(1, 'days')"
            format="YYYY-MM-DD"
            :placeholder="['Start Time开始时间', '结束时间']"
            style="width: 100%;"
          />
        </a-form-item> -->
  <!-- execute time -->
  <!-- <a-form-item label="时间" v-if="planBody.task_type === TaskType.Timed || planBody.task_type === TaskType.Condition"
          name="select_execute_time" ref="select_execute_time" :labelCol="{span: 23}" :autoLink="false">
          <div class="mb10 flex-row flex-align-center flex-justify-around" v-for="n in planBody.select_time_number" :key="n">
            <a-time-picker
              v-model:value="planBody.select_time[n - 1][0]"
              format="HH:mm:ss"
              show-time
              placeholder="开始时间"
              :style="planBody.task_type === TaskType.Condition ? 'width: 40%' : 'width: 82%'"
              @change="() => $refs.select_execute_time.onFieldChange()"
            />
            <template v-if="planBody.task_type === TaskType.Condition">
              <div><span style="color: white;">-</span></div>
              <a-time-picker
                v-model:value="planBody.select_time[n - 1][1]"
                format="HH:mm:ss"
                show-time
                placeholder="结束时间"
                style="width: 40%;"
              />
            </template>
            <div class="ml5" style="font-size:18px">
              <PlusCircleOutlined class="mr5" style="color: #1890ff" @click="addTime"/>
              <MinusCircleOutlined :style="planBody.select_time_number === 1 ? 'color: gray' : 'color: red;'" @click="removeTime"/>
            </div>
          </div>
        </a-form-item>
        <template v-if="planBody.task_type === TaskType.Condition"> -->
  <!-- battery capacity -->
  <!-- <a-form-item label="开始任务时电池电量达到" :labelCol="{span: 23}" name="min_battery_capacity">
            <a-input-number class="width-100" v-model:value="planBody.min_battery_capacity" :min="50" :max="100"
            :formatter="(value: number) => `${value}%`" :parser="(value: string) => value.replace('%', '')">
            </a-input-number>
          </a-form-item> -->
  <!-- storage capacity -->
  <!-- <a-form-item label="开始任务时存储空间达到(MB)" :labelCol="{span: 23}" name="storage_capacity">
            <a-input-number v-model:value="planBody.min_storage_capacity" class="width-100">
            </a-input-number>
          </a-form-item>
        </template> -->
  <!-- RTH Altitude Relative to Dock -->
  <!-- <a-form-item label="RTH 高度相对地面站(m)" :labelCol="{span: 23}" name="rth_altitude">
          <a-input-number v-model:value="planBody.rth_altitude" :min="20" :max="1500" class="width-100" required>
          </a-input-number>
        </a-form-item> -->
  <!-- Lost Action -->
  <!-- <a-form-item label="失联动作" :labelCol="{span: 23}" name="out_of_control_action">
          <div style="white-space: nowrap;">
            <a-radio-group v-model:value="planBody.out_of_control_action" button-style="solid">
              <a-radio-button v-for="action in OutOfControlActionOptions" :value="action.value" :key="action.value">
                {{ action.label }}
              </a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item>
        <a-form-item class="width-100" style="margin-bottom: 40px;">
          <div class="footer-container">
          <div class="footer">
            <a-button class="mr10" style="background: #3c3c3c;" @click="closePlan">取消
            </a-button>
            <a-button type="primary" @click="onSubmit" :disabled="disabled">确定
            </a-button>
          </div>
          </div>
        </a-form-item>
      </a-form>
    </div>
    </div>
  </div>
  <div v-if="drawerVisible" style="position: absolute; left: 335px; width: 280px; height: 100vh; float: right; top: 0; z-index: 1000; color: white; background: #282828;">
    <div>
      <router-view :name="routeName"/>
    </div>
    <div style="position: absolute; top: 15px; right: 10px;">
      <a style="color: white;" @click="closePanel"><CloseOutlined /></a>
    </div>
  </div> -->
</template>

<script lang="ts" setup>
import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue'
import { CloseOutlined, RocketOutlined, CameraFilled, UserOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons-vue'
import { ELocalStorageKey, ERouterName } from '/@/types'
import { useMyStore } from '/@/store'
import { WaylineFile } from '/@/types/wayline'
import { Device, DEVICE_NAME } from '/@/types/device'
import { createPlan, CreatePlan } from '/@/api/wayline'
import { getRoot } from '/@/root'
import { TaskType, OutOfControlActionOptions, OutOfControlAction, TaskTypeOptions } from '/@/types/task'
import moment, { Moment } from 'moment'
import { RuleObject } from 'ant-design-vue/es/form/interface'
import { getDictDataList } from '/@/api/algCode'
import { getUserDronePilotsByDepartment } from '/@/api/polituser'
import { getAllSpecialData, getAllSpecialTree } from '/@/api/insp/insp-regulations'
import { message } from 'ant-design-vue'

interface SpecialTreeNode {
  id: number;
  code: string;
  name: string;
  parentId: number;
  parentName: string | null;
  status: number;
  sort: number;
  remark: string | null;
  createBy: string | null;
  createTime: string;
  updateBy: string | null;
  updateTime: string;
  children?: SpecialTreeNode[];
}

interface TreeSelectNode {
  key: number;
  title: string;
  value: number;
  children?: TreeSelectNode[];
  isLeaf?: boolean;
  rawData?: SpecialTreeNode;
}

interface SpecialThirdNode {
  id: number;
  name: string;
  category: string;
}

const root = getRoot()
const store = useMyStore()

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!

const wayline = computed<WaylineFile>(() => {
  return store.state.waylineInfo || {} as WaylineFile
})

const dock = computed<Device>(() => {
  return store.state.dockInfo || {} as Device
})

const disabled = ref(false)

const routeName = ref('')

const planBody = reactive({
  name: '',
  file_id: computed(() => wayline.value?.id || ''),
  dock_sn: computed(() => dock.value?.device_sn || ''),
  task_type: TaskType.Immediate,
  select_execute_date: [moment().add(1, 'days').startOf('day'), moment().add(7, 'days').startOf('day')] as Moment[],
  select_time_number: 1,
  select_time: [[]] as Moment[][],
  rth_altitude: 200,
  out_of_control_action: OutOfControlAction.ReturnToHome,
  min_battery_capacity: 90 as number,
  min_storage_capacity: undefined as number | undefined,
  job_type: null,
  is_analysis: false,
  generate_report: false,
  remark: '',
  pilot_id: null,
  pilot_name: null,
  specialTopicId: null,
  portion: '', // 专题应用
  portion_code: '', // 专题应用编码
  portion_type: ''
})

// const specialTopicId = ref(null)
const specialTopicList = ref<TreeSelectNode[]>([])

const convertToTreeSelectNodes = (nodes: SpecialTreeNode[]): TreeSelectNode[] => {
  if (!nodes || nodes.length === 0) return []

  return nodes.map((node) => {
    const treeNode: TreeSelectNode = {
      key: node.id,
      title: node.name,
      value: node.id,
      rawData: node,
      isLeaf: !node.children || node.children.length === 0
    }
    if (node.children && node.children.length > 0) {
      treeNode.children = convertToTreeSelectNodes(node.children)
    }
    return treeNode
  })
}

const loadSpecialListTree = async () => {
  try {
    // 1. 获取前两层数据
    const treeRes = await getAllSpecialTree()
    const rawTreeData: SpecialTreeNode[] = treeRes.data || []

    // 2. 获取所有第三层数据
    const thirdRes = await getAllSpecialData()
    const thirdNodes: SpecialThirdNode[] = thirdRes.data || []

    // 3. 构建映射：第二层节点的 code -> 第三层节点列表
    const childrenMap = new Map<string, SpecialThirdNode[]>()
    thirdNodes.forEach(node => {
      const category = node.category
      if (!childrenMap.has(category)) {
        childrenMap.set(category, [])
      }
      childrenMap.get(category)!.push(node)
    })

    // 4. 将第三层节点挂载到对应的第二层节点下
    const processedTree = rawTreeData.map(rootNode => {
      // 处理第二层子节点
      if (rootNode.children && rootNode.children.length) {
        rootNode.children = rootNode.children.map(secondNode => {
          const matchedChildren = childrenMap.get(secondNode.code) || []
          // 将匹配的第三层节点转换为 SpecialTreeNode 格式（便于后续统一转换）
          const thirdLevelChildren = matchedChildren.map(third => ({
            id: third.id,
            name: third.appName,
            code: third.appCode,
            type: third.type,
            category: third.category,
            parentId: secondNode.id,
            parentName: secondNode.name,
            status: 1,
            sort: 0,
            remark: null,
            createBy: null,
            createTime: '',
            updateBy: null,
            updateTime: '',
            children: [] // 第三层视为叶子节点
          } as SpecialTreeNode))
          // 将第三层节点赋值给第二层节点的 children
          return {
            ...secondNode,
            children: thirdLevelChildren
          }
        })
      }
      return rootNode
    })

    // 5. 转换为 TreeSelect 所需格式
    specialTopicList.value = convertToTreeSelectNodes(processedTree)
  } catch (error) {
    console.error('加载专题树失败:', error)
    message.error('加载专题树失败')
  }
}

// 递归查找节点
const findNodeInTree = (nodes: TreeSelectNode[], targetValue: number): TreeSelectNode | null => {
  for (const node of nodes) {
    if (node.value === targetValue) return node
    if (node.children) {
      const found = findNodeInTree(node.children, targetValue)
      if (found) return found
    }
  }
  return null
}

const handleSpecialTopicChange = async (value: number | null) => {
  if (!value) {
    planBody.portion = ''
    planBody.portion_code = ''
    planBody.portion_type = ''
    planBody.specialTopicId = null
    await nextTick()
    valueRef.value?.clearValidate('specialTopicId')
    return
  }

  const selectedNode = findNodeInTree(specialTopicList.value, value)
  if (!selectedNode) return

  // 判断是否为叶子节点
  if (selectedNode.children && selectedNode.children.length > 0) {
    message.warning('只能选择最后一级专题')
    planBody.specialTopicId = null
    planBody.portion = ''
    planBody.portion_code = ''
    planBody.portion_type = ''
    await nextTick()
    valueRef.value?.clearValidate('specialTopicId')
    return
  }

  // 叶子节点：赋值专题信息
  const raw = selectedNode.rawData as any
  if (raw) {
    planBody.portion = raw.name || ''
    planBody.portion_code = raw.code || ''
    planBody.portion_type = raw.type || ''
  } else {
    planBody.portion = ''
    planBody.portion_code = ''
    planBody.portion_type = ''
  }
  // 确保 specialTopicId 已绑定（v-model 会自动赋值，但显式更安全）
  planBody.specialTopicId = value

  // 关键：等待 DOM 更新后清除校验错误
  await nextTick()
  valueRef.value?.clearValidate('specialTopicId')
}

const pilotData = ref([])
const getPilotData = () => {
  getUserDronePilotsByDepartment().then((res) => {
    if (res.data) {
      pilotData.value = res.data
    }
  })
}

const drawerVisible = ref(false)
const valueRef = ref()
const rules = {
  name: [
    { required: true, message: '请输入计划名称' },
    { max: 20, message: '长度应为1到20' }
  ],
  file_id: [{ required: true, message: '请选择航线' }],
  dock_sn: [{ required: true, message: '请选择设备' }],
  // job_type: [{ required: true, message: '请选择任务场景' }],
  specialTopicId: [{ required: true, message: '请选择关联专题' }],
  pilotId: [{ required: true, message: '请选择飞手' }],
  select_execute_time: [{
    validator: async (rule: RuleObject, value: Moment[]) => {
      validEndTime()
      validStartTime()
      if (planBody.select_time.length < planBody.select_time_number) {
        throw new Error('请选择时间')
      }
      validOverlapped()
    }
  }],
  select_execute_date: [{ required: true, message: '请选择日期' }],
  /* rth_altitude: [
    {
      validator: async (rule: RuleObject, value: string) => {
        if (!/^[0-9]{1,}$/.test(value)) {
          throw new Error('RTH 高度要求数字')
        }
      },
    }
  ], */
  min_battery_capacity: [
    {
      validator: async (rule: RuleObject, value: any) => {
        if (TaskType.Condition === planBody.task_type && !value) {
          throw new Error('请输入电池电量')
        }
      },
    }
  ],
  out_of_control_action: [{ required: true, message: '请选择失联动作' }],
}

function validStartTime (): Error | void {
  for (let i = 0; i < planBody.select_time.length; i++) {
    if (!planBody.select_time[i][0]) {
      throw new Error('请选择开始时间')
    }
  }
}
function validEndTime (): Error | void {
  if (TaskType.Condition !== planBody.task_type) return
  for (let i = 0; i < planBody.select_time.length; i++) {
    if (!planBody.select_time[i][1]) {
      throw new Error('请选择结束时间')
    }
    if (planBody.select_time[i][0] && planBody.select_time[i][1].isSameOrBefore(planBody.select_time[i][0])) {
      throw new Error('结束时间应晚于开始时间')
    }
  }
}
function validOverlapped (): Error | void {
  if (TaskType.Condition !== planBody.task_type) return
  const arr = planBody.select_time.slice()
  arr.sort((a, b) => a[0].unix() - b[0].unix())
  arr.forEach((v, i, arr) => {
    if (i > 0 && v[0] < arr[i - 1][1]) {
      throw new Error('时间重叠')
    }
  })
}

const jobTypeData = ref('')
const fetchJobTypeData = async () => {
  const res = await getDictDataList('task_scenario')
  if (res && res.code === 200) {
    jobTypeData.value = res.data || []
  }
}

const handlePilotChange = (value) => {
  const selected = pilotData.value.find(item => item.id === value)
  planBody.pilotName = selected ? selected.username : null
}

function onSubmit () {
  // console.info(dock, '12131231')
  valueRef.value.validate().then(() => {
    disabled.value = true
    const createPlanBody = { ...planBody } as unknown as CreatePlan
    // createPlanBody.pilot_id = planBody.pilotId
    // createPlanBody.pilot_name = planBody.pilotName
    if (planBody.select_execute_date.length === 2) {
      createPlanBody.task_days = []
      for (let i = planBody.select_execute_date[0]; i.isSameOrBefore(planBody.select_execute_date[1]); i.add(1, 'days')) {
        createPlanBody.task_days.push(i.unix())
      }
    }
    createPlanBody.task_periods = []
    if (TaskType.Immediate !== planBody.task_type) {
      for (let i = 0; i < planBody.select_time.length; i++) {
        const result = []
        result.push(planBody.select_time[i][0].unix())
        if (TaskType.Condition === planBody.task_type) {
          result.push(planBody.select_time[i][1].unix())
        }
        createPlanBody.task_periods.push(result)
      }
    }
    createPlanBody.rth_altitude = Number(createPlanBody.rth_altitude)
    if (wayline.value && wayline.value.template_types && wayline.value.template_types.length > 0) {
      createPlanBody.wayline_type = wayline.value.template_types[0]
    }
    createPlan(workspaceId, createPlanBody)
      .then(res => {
        disabled.value = false
      }).finally(() => {
        closePlan()
      })
  }).catch((e: any) => {
    console.log('validate err', e)
  })
}

function closePlan () {
  root.$router.push('/' + ERouterName.TASK)
}

function closePanel () {
  drawerVisible.value = false
  routeName.value = ''
  store.commit('SET_WAYLINE_TEMPLATE', false)
  store.commit('SET_WAYLINE_DEVICE', false)
  store.commit('SET_SELECT_WAYLINE_INFO', null)
}

function selectRoute () {
  if (!drawerVisible.value) {
    store.commit('SET_SELECT_WAYLINE_INFO', null)
  }
  drawerVisible.value = true
  routeName.value = 'WaylinePanel'
  store.commit('SET_WAYLINE_DEVICE', false)
  store.commit('SET_WAYLINE_TEMPLATE', true)
}

function selectDevice () {
  drawerVisible.value = true
  routeName.value = 'DockPanel'
  store.commit('SET_SELECT_WAYLINE_INFO', null)
  store.commit('SET_WAYLINE_DEVICE', true)
  store.commit('SET_WAYLINE_TEMPLATE', false)
}

function addTime () {
  valueRef.value.validateFields(['select_execute_time']).then(() => {
    planBody.select_time_number++
    planBody.select_time.push([])
  })
}
function removeTime () {
  if (planBody.select_time_number === 1) return
  planBody.select_time_number--
  planBody.select_time.splice(planBody.select_time_number)
}

onMounted(() => {
  fetchJobTypeData()
  getPilotData()
  loadSpecialListTree()
})

onUnmounted(() => {
  store.commit('SET_WAYLINE_TEMPLATE', false)
  store.commit('SET_WAYLINE_DEVICE', false)
  store.commit('SET_SELECT_WAYLINE_INFO', null)
})
</script>

<style lang="scss" scpoed>
.content {
  height: 760px;
  overflow-y: auto;
  scrollbar-width: none;
  margin: 10px;

  form label,
  input,
  .ant-input,
  .ant-calendar-picker-input,
  .ant-input:hover {
    background-color: #232323;
    color: #fff;
  }

  .ant-input-suffix {
    color: #fff;
  }

  .plan-timer-form-item {
    .ant-radio-button-wrapper {
      background-color: #232323;
      color: #fff;
      width: 32%;
      text-align: center;

      &.ant-radio-button-wrapper-checked {
        background-color: #1890ff;
      }
    }
  }

  .out_of_control_action {
    .ant-radio-button-wrapper {
      width: 35%;
    }
  }
}

// .range-pi .ant-calendar-range-picker-separator {
//   background-color: #232323;
//   color: #fff;
// }

// .ant-calendar-picker .anticon {
//   background-color: #232323 !important;
// }

// .ant-time-picker .anticon {
//   background-color: #232323 !important;
// }

// .range-pi .ant-picker {
//   background-color: #232323 !important;
// }

// .ant-time-picker-input {
//   background-color: #232323 !important;
// }

// .ant-picker-panel-container {
//   background-color: #232323 !important;
// }

.footer {
  height: 50px;
  width: 283px;
  position: fixed;
  bottom: 0;
  display: flex;
  padding-top: 10px;
  //margin-left: 70px;
  border-top: 1px solid #4f4f4f;

  button {
    width: 35%;
    color: #fff;
    border: 0;
    margin-left: 25px;

  }
}

.wayline-panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 90px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;

  .title {
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 70px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;

  .title {
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

// .range-pi {
//   width: 98%;
//   background-color: #fff !important;
//   color: #232323;
// }

// .range-pi.ant-calendar-picker-input {
//   background-color: #fff !important;
//   color: #fff;
// }

/*.create-plan-wrapper {
  background-color: #232323;
  color: fff;
  padding-bottom: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  width: 285px;

  .header {
    height: 52px;
    width: 285px;
    border-bottom: 1px solid #4f4f4f;
    font-weight: 700;
    font-size: 16px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .content {
    height: 790px;
    background-color: aqua;
    overflow-y: auto;
    margin: 10px;

    form {
      margin: 10px;
    }

    form label, input, .ant-input, .ant-calendar-range-picker-separator,
    .ant-input:hover, .ant-time-picker .anticon, .ant-calendar-picker .anticon {
      background-color: #232323;
      color: #fff;
    }

    .ant-input-suffix {
      color: #fff;
    }

    .plan-timer-form-item {

      .ant-radio-button-wrapper{
        background-color: #232323;
        color: #fff;
        width: 15%;
        text-align: center;
        &.ant-radio-button-wrapper-checked{
          background-color: #1890ff;
        }
      }
    }
  }

.footer-container{
  width: 100%;
  position: fixed;
  bottom: 0;
  margin-left: 30px;
  z-index: 100;
}
  .footer {
    width: 200px;
    height: 50px;
    position: fixed;
    bottom: 0;
    display: flex;
    padding:10px 0;
    gap:10px;

    button {
      width: 50%;
      color: #fff ;
      border: 0;

    }
  }
}

.wayline-panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 90px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  .title {
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 70px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  .title {
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}*/
</style>
